import { useEffect } from 'react';
import { Modal, Spin } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';
import {
  useCreateVoiceActor,
  useEditVoiceActor,
  useGetVoiceActorByIdMultilingual,
} from '@wajeez-web/components/helpers';
import { WajeezMultilingualFormBuilder } from '@wajeez-web/components/form-builder';
import {
  clearVoiceActorByIdMultilingual,
  createVoiceActor,
  editVoiceActor,
  getVoiceActorByIdMultilingual,
} from '@wajeez-web/stores/content';
import { Languages } from '@wajeez-web/core/utils';

export interface VoiceActorModalProps extends CommonModalProps<string> {
  id?: string;
}

type Input = {
  name: string;
  about: string;
};

const VoiceActorModal = ({
  isOpen,
  onClose,
  onSubmit,
  id,
}: VoiceActorModalProps) => {
  const { status: createVoiceActorStatus } = useCreateVoiceActor();
  const { status: editVoiceActorStatus } = useEditVoiceActor();

  const { status, data } = useGetVoiceActorByIdMultilingual();

  useEffect(() => {
    if (id) {
      getVoiceActorByIdMultilingual(id);
    }

    return () => {
      clearVoiceActorByIdMultilingual();
    };
  }, [id]);

  return (
    <Modal
      title={'Voice Actor'}
      open={isOpen}
      onClose={onClose}
      alertTarget="modal"
      fontClassName="font-[Tajawal]"
      handleAlert
    >
      {status === 'loading' ? (
        <div className="h-[400px] flex justify-center items-center">
          <Spin />
        </div>
      ) : (
        <div className="pb-14 overflow-y-auto">
          <WajeezMultilingualFormBuilder<Server.CreateVoiceActorCommand>
            rows={{}}
            profileRows={{
              name: {
                fieldType: Server.FieldType.Text,
                fieldOptions: {},
                label: 'Name',
                placeHolder: 'Name',
                required: true,
              },
            }}
            onSubmit={(data) => {
              if (!id) {
                createVoiceActor(data, onSubmit);
              } else {
                editVoiceActor(
                  {
                    id,
                    ...data,
                  },
                  onSubmit
                );
              }
            }}
            onCancel={onClose}
            isUpdate={
              createVoiceActorStatus === 'loading' ||
              editVoiceActorStatus === 'loading'
            }
            formValues={
              data || {
                profiles: [
                  {
                    languageId: Languages.AR,
                  },
                ],
              }
            }
          />
        </div>
      )}
    </Modal>
  );
};

export default VoiceActorModal;
